module.exports = __webpack_public_path__ + "static/img/dnsd_logo.0b99656.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dnsd_logo.png
// module id = +PWU
// module chunks = 1